export default {"src":"/_next/static/media/email_verificated.eb67a67c.svg","height":133,"width":152};